import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import SpacingContainerBase from '../../components/layouts/SpacingContainerBase'
import DetailsAnchorsHeader from '../../components/generics/DetailsAnchorsHeader'
import SectionScrollable from '../../components/common/Containers/SectionScrollable'
import NothingFoundCard from '../../components/generics/Cards/NothingFoundCard'
import { V_REGISTERED_USER } from '../../utils/helpers'
import Loader from '../../components/common/Loader'
import SummaryUser from './Summary'
import connect from './connect'
import { useParams } from 'react-router-dom'
import SavedSearches from './SavedSearches/SavedSearches'
import AssignedOrganizations from './AssignedOrganizations'
import { useSelector } from 'react-redux'
import { useTrans } from '../../services/i18n'
import { useAlertContext } from '../../contexts/AlertContext'
import { selectUserPermissions, isEnabled } from '../../selectors'

const RegisteredUserDetail = ({ findOne }) => {
  const params = useParams()
  const { trans } = useTrans()
  const { errorAlert } = useAlertContext()
  const [pending, setPending] = useState(true)
  const [user, setUser] = useState(null)
  const permissions = useSelector(selectUserPermissions)

  useEffect(() => {
    setPending(true)
    findOne({ id: params.id })
      .then(res => {
        if (res.error) {
          errorAlert(res.error.message)
        }
        setUser(res.payload || null)
      })
      .finally(() => setPending(false))
  }, [params.id])

  const [savedSearchTab] = isEnabled(permissions, 'registered-users', [
    'saved-searches',
  ])

  return (
    <SectionScrollable
      TopFixed={
        <DetailsAnchorsHeader
          anchors={
            savedSearchTab?.view
              ? V_REGISTERED_USER
              : V_REGISTERED_USER.filter(item => item.id !== 'saved-searches')
          }
          backLink={`/users`}
          onPrint={undefined}
        />
      }
    >
      {pending && <Loader open={pending} />}
      {!pending && !user && (
        <SpacingContainerBase py={0}>
          <NothingFoundCard title={trans('nothing-found')} size="medium" py={10} />
        </SpacingContainerBase>
      )}
      {!pending && user && (
        <SpacingContainerBase py={0}>
          <div id="account">
            <SummaryUser item={user} />
          </div>
          <div id="assigned-organizations">
            <AssignedOrganizations organizations={user.organizations || []} />
          </div>
          {savedSearchTab?.view && (
            <div id="saved-searches">
              <SavedSearches />
            </div>
          )}
        </SpacingContainerBase>
      )}
    </SectionScrollable>
  )
}

RegisteredUserDetail.propTypes = {
  findOne: PropTypes.func.isRequired,
}

export default connect(RegisteredUserDetail)
